import React, { useState, useEffect, useRef } from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { FixedSizeList as List } from 'react-window'
import Dialog from '@mui/material/Dialog';
import { Alert, AlertTitle } from '@mui/material';
import { ImageListItem } from '@mui/material';
import ButtonGroup from '@mui/material/ButtonGroup';
import MapButton from '../MapView/mapButton';
import { ArrowLeftSquareFill } from 'react-bootstrap-icons';
import Tooltip from '@mui/material/Tooltip';
import StarIcon from '@mui/icons-material/Star';
import CardActionArea from '@mui/material/CardActionArea';
import PrintPDFRef from '../PrintRefeference/PrintPDFRef';
import PrintRefExcel from '../PrintRefeference/PrintRefExcel';
import SelectAllButton from './SelectAllButton';
import { withTranslation } from 'react-i18next';
import setShowRefAction from '../../redux/actions/showReferenceActions/actionShowRef';
import setPrintPDFAction from '../../redux/actions/showReferenceActions/actionPDFPrint';
import setScroolPositionAction from '../../redux/actions/showReferenceActions/actionScrollPosition';
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from "react-router-dom";
import Menu from '../MenuBar';
import { styled } from '@mui/material/styles';


const RootDiv = styled('div')({
    display: 'flex',
    justifyContent: 'center'
});

const StyledCard = styled(Card)(({ theme }) => ({
    backgroundColor: 'rgba(19, 174, 236, 0.54)'
}));

const SyledCardMedia = styled(CardMedia)({
    paddingTop: '56%'
});

const StyledOverlayCardContent = styled(CardContent)({
        position: 'absolute',
        display: 'flex',
        justifyContent: 'left',
        textAlign: 'left',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        color: 'black',
        backgroundColor: 'rgba(0, 0, 0, 0.3)'
});

const ShowRef = ({ t }) => {

    const [pdfPrintData, setPdfPrintData] = useState([]);
    const [checkBoxes, setCheckBoxes] = useState([]);
    const [open, setOpen] = useState(true);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [matches, setMatches] = useState(window.matchMedia("(min-width: 768px)").matches);

    const referencesData = useSelector(state => state.searchRefState.referencesData)
    const scrollPositionSet = useSelector(state => state.showRefState.scrollPosition)
    const selectAllButton = useSelector(state => state.searchRefState.selectAllButton)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const myRef = useRef();

useEffect(() => {
    const handler = e => setMatches(e.matches);
    const matchMedia = window.matchMedia("(min-width: 768px)");
    matchMedia.addEventListener('change', handler);
    // // Event Listener hinzufügen
    // matchMedia.addListener(handler);

    // Scroll-Position wiederherstellen, falls vorhanden
    if (myRef.current) {
        myRef.current.scrollTo(scrollPositionSet);
    }

    // Setze alle Checkboxen und PDF-Daten
    if (referencesData.data) {
        const updatedCheckBoxes = referencesData.data.map(item => selectAllButton ? item.id.toString() : '');
        setCheckBoxes(updatedCheckBoxes);
        if (selectAllButton) {
            setPdfPrintData(referencesData.data);
            dispatch(setPrintPDFAction(referencesData.data));
        } else {
            setPdfPrintData([]);
            dispatch(setPrintPDFAction([]));
        }
    }

    // Event Listener beim Cleanup entfernen
    return () => {
        matchMedia.removeEventListener('change', handler);
    };
}, [selectAllButton]);

    const handleCardAction = (selectedReferenceData) => {
        dispatch(setScroolPositionAction(scrollPosition))
        dispatch(setShowRefAction(selectedReferenceData))
        navigate(`/viewRefDetails/${selectedReferenceData.id}`);
    }

    const handleCloseDialog = () => {
        setOpen(false);
    };

    const handleBack = () => {
        navigate(-1);
    }

    const gridScroll = (scrollPosition) => {
        setScrollPosition(scrollPosition.scrollOffset);
    };


    const handleChangeCheckBox = (event, referencesData) => {

        let newCheckBoxes = [...checkBoxes];
        let selectedReferenceData = []
        let checkboxID = event.target.id;
        if (event.target.checked) {
            selectedReferenceData = referencesData.item.find(item => item.id.toString() === checkboxID);
            setPdfPrintData([...pdfPrintData, selectedReferenceData]);
            dispatch(setPrintPDFAction([...pdfPrintData, selectedReferenceData]))
            //Hinzufügen von Aktion
            newCheckBoxes.push(event.target.id);
        } else {
            //Entfernen von Aktion
            const index = newCheckBoxes.indexOf(event.target.id);
            newCheckBoxes.splice(index, 1);

            //Wenn CheckBoxen leer, return alle Daten für PDF-Druck
            if (newCheckBoxes.length === 0) {
                //Wenn CheckBoxen leer, return alle Daten für PDF-Druck
                setPdfPrintData(referencesData.item)
                dispatch(setPrintPDFAction(referencesData.item))
            } else {
                //sonst nur die ausgewälten
                setPdfPrintData(pdfPrintData.filter(element => element.id.toString() !== checkboxID));
                dispatch(setPrintPDFAction(pdfPrintData.filter(element => element.id.toString() !== checkboxID)))
            }
        }
        setCheckBoxes(newCheckBoxes);
    }

    const SearchGrid = ({ index, style, data }) => {
        const { item } = data;
        // const { item, classes, t, handleCardAction, handleChangeCheckBox, checkBoxes } = data;
        const referenceData = item[index];
        if (referenceData.image1 !== undefined) {
            let imagePath = referenceData.image1.substring(referenceData.image1.lastIndexOf('-') + 1, referenceData.image1.lastIndexOf('.'));
            return (
                <div style={style}>
                    <ImageListItem key={referenceData.id} sx={{ margin: 1, padding: 0, loading: "lazy" }}>
                        <StyledCard key={referenceData.id} style={{ backgroundColor: 'rgba(19, 174, 236, 0.54)' }}>
                            <CardActionArea onClick={() => handleCardAction(referenceData)}>
                                <SyledCardMedia
                                    image={`${process.env.REACT_APP_EXPRESS_SERVER}/ImagesForPDF/${imagePath}/${referenceData.image1}`}
                                    height="150"
                                />
                                <StyledOverlayCardContent>
                                    <Typography style={{ color: 'white' }} color="textSecondary" component="p">
                                        <b>{t('create_ref.title')}:</b> {referenceData.title} {referenceData.contestRelease === 'true' ? (<StarIcon style={{ fill: "gold" }} />) : null}
                                        <br />
                                        <b>{t('create_ref.country')}:</b> {referenceData.country}
                                        <br />
                                        <b>{t('create_ref.city')}:</b> {referenceData.city}
                                    </Typography>
                                </StyledOverlayCardContent>
                            </CardActionArea>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color="secondary"
                                        id={referenceData.id.toString()}
                                        checked={checkBoxes.includes(referenceData.id.toString())}
                                        onChange={(event) => { handleChangeCheckBox(event, data) }}
                                    />
                                }
                                label={<Typography style={{ position: 'absolute', right: 10, top: 420, fontSize: 12, fontWeight: 'bold' }}>
                                    {referencesData.externalRelease === "true" ? t("view_ref.external_release") : null}</Typography>}
                            />
                        </StyledCard>
                    </ImageListItem>
                </div>
            );
        }
    };

    return (
        <div className='viewRefClassFull' >
            <Menu />
            <RootDiv>
                {referencesData ? (
                    <div>
                        <ButtonGroup size="small" aria-label="small outlined button group">
                            <Tooltip placement="left" title={<h6 style={{ color: "white" }}>Go back</h6>}>
                                <Button
                                    onClick={handleBack}
                                    style={{ width: 80, marginTop: 5, marginBottom: 10, backgroundColor: 'rgba(19, 174, 236, 0.54)' }}
                                    variant="contained" color="primary" size="medium"
                                    startIcon={<ArrowLeftSquareFill style={{ color: 'white' }} />}
                                />
                            </Tooltip>
                            <PrintPDFRef />
                            <PrintRefExcel />
                            <MapButton />
                        </ButtonGroup>
                        <SelectAllButton />
                        {/* ################################################## RESPONSIVE ################################################## */}

                        {matches && (
                            <List height={800} itemCount={referencesData.data.filter(item => item.image1).length}
                                itemSize={470} ref={myRef} style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)', width: 768, height: 800, margin: 0, padding: 0 }}
                                itemData={{
                                    item: referencesData.data.filter(item => item.image1),
                                    t,
                                    handleCardAction,
                                    handleChangeCheckBox,
                                    checkBoxes,
                                }}
                                onScroll={gridScroll}
                            >
                                {SearchGrid}
                            </List>)}

                        {/* ########################################################################################################### */}

                        {!matches && (<List height={800} itemCount={referencesData.data.filter(item => item.image1).length}
                            itemSize={220} ref={myRef} style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)', width: 320, height: 800, margin: 0, padding: 0 }}
                            itemData={{
                                item: referencesData.data.filter(item => item.image1),
                                t,
                                handleCardAction,
                                handleChangeCheckBox,
                                checkBoxes,
                            }}
                        >
                            {SearchGrid}
                        </List>)}
                    </div >
                ) : (
                    <div>
                        <Dialog onClose={handleCloseDialog} aria-labelledby="simple-dialog-title" open={open}>
                            <Alert severity="error">
                                <AlertTitle>Error</AlertTitle>
                                {t("view_ref.view_error")}
                            </Alert>
                        </Dialog>
                    </div >
                )}
            </RootDiv >
        </div >
    );
};


export default (withTranslation()(ShowRef));